import {
  trigger,
  animate,
  transition,
  style,
  state
} from '@angular/animations';
import { ANIMATION } from './animation.constants';

export const fadeIn = trigger('fadeIn', [
  state('hidden', style({ opacity: 0 })),
  state('visible', style({ opacity: 1 })),
  transition('hidden <=> visible', animate('300ms ease-in-out')),
]);